// @flow

import { connect } from 'react-redux';
import { compose } from 'redux';

import { withPageMeta } from '@gandi/app-runner';
import { withTranslator } from '@gandi/translate';

import { fetchRenewableProducts } from 'src/DomainRenew/components/modules/actions';
import { withRouter } from 'src/helpers/withRouter';

import type { FullState } from '../types';

import Presenter, { type PresenterStateProps } from './components/Presenter';
import {
  fetchResultsQuotation,
  validateSearch as submitSearch,
  addRewableResults,
} from './modules/actions';
import { selectSearch, selectExtendedResults } from './modules/selectors';

const mapStateToProps = (state: FullState): Partial<PresenterStateProps> => ({
  search: selectSearch(state),
  results: selectExtendedResults(state),
});

const mapDispatchToProps = {
  fetchRenewableProducts,
  fetchResultsQuotation,
  submitSearch,
  addRewableResults,
};

export default (compose(
  withTranslator({ propsNamespace: 'translator' }),
  withPageMeta(args => ({
    title: args.__('Renew your domain name - Gandi.net'),
    description: args.__('Renew your domain name.'),
  })),
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
)(Presenter): React.ComponentType<{}>);
